import { render, staticRenderFns } from "./main-apps.vue?vue&type=template&id=52c63549&scoped=true&"
import script from "./main-apps.vue?vue&type=script&lang=js&"
export * from "./main-apps.vue?vue&type=script&lang=js&"
import style0 from "./main-apps.vue?vue&type=style&index=0&id=52c63549&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c63549",
  null
  
)

export default component.exports